import { Typography, List } from 'antd';

const { Title, Paragraph, Text } = Typography;

export const generateSendoutsDrawerText = () => (
  <Typography>
    <Paragraph>
      В этом разделе вы можете управлять массовыми рассылками организации.
    </Paragraph>

    <Title level={4}>Что можно делать</Title>
    <List
      size="small"
      dataSource={[
        'Просматривать информацию о всех рассылках.',
        'Просматривать детали конкретной рассылки.',
        'Редактировать уже запущенные рассылки.',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />

    <Title level={4}>Поиск рассылки</Title>
    <Paragraph>Вы можете находить нужную рассылку с помощью:</Paragraph>
    <List
      size="small"
      dataSource={[
        'Поиска по названию или части текста рассылки.',
        'Фильтров: статусы, каналы, интеграции.',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
    <Paragraph>
      Используйте кнопку <Text strong>“Поиск”</Text> для поиска или фильтров,
      кнопку <Text strong>“Сброс”</Text> для очистки.
    </Paragraph>

    <Title level={4}>Параметры рассылки</Title>
    <List
      size="small"
      dataSource={[
        'Название',
        'Канал, интеграция',
        'Старт',
        'Получатели',
        'Отправлено',
        'Ответили',
        'Записались',
        'Конверсия, %',
        'Сумма',
        'Статус',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />

    <Title level={4}>Действия со статусом</Title>
    <List
      size="small"
      dataSource={[
        'Посмотреть детали рассылки (всегда доступно).',
        'Поставить на паузу (если запущена, но не завершена).',
        'Редактировать (если запущена, но не завершена).',
        'Запустить (если была на паузе).',
        'Остановить (если запущена или на паузе).',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />

    <Title level={4}>Детальная информация</Title>
    <Paragraph>
      Нажав на название рассылки или значок <Text strong>“глаз”</Text>, вы
      перейдете в режим просмотра деталей.
    </Paragraph>
    <List
      size="small"
      dataSource={[
        'ID',
        'Название',
        'Канал, интеграция',
        'Количество получателей',
        'Теги после отправки',
        'Периодичность',
        'Создана',
        'Старт',
        'Статус',
        'График рассылки',
        'Содержание рассылки',
        'Список получателей',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />

    <Title level={4}>Редактирование рассылки</Title>
    <Paragraph>
      После остановки рассылки можно редактировать её параметры:
    </Paragraph>
    <List
      size="small"
      dataSource={[
        'Текст сообщения',
        'Медиафайлы',
        'Список тегов',
        'Периодичность',
        'График отправки',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
    <Paragraph>
      Нажмите <Text strong>“Сохранить”</Text> для фиксации изменений и снова
      запустите рассылку.
    </Paragraph>

    <Title level={4}>Создание рассылки</Title>
    <Paragraph>
      В разделе <Text strong>«Клиенты»</Text> выполните следующие шаги:
    </Paragraph>
    <List
      size="small"
      dataSource={[
        'Выберите получателей для рассылки.',
        'Создайте рассылку (Действие → Отправить сообщение → Только для выбранных).',
        'Настройте и запустите рассылку.',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
    {/* TODO временно убираем */}
    {/* <Title level={4}>Видео-инструкции</Title>
    <Paragraph>
      <Text strong>Видео 1:</Text> Просмотр и редактирование рассылок.
    </Paragraph>
    <List
      size="small"
      dataSource={[
        'Переход в раздел “Рассылки”.',
        'Демонстрация реестра и фильтров.',
        'Просмотр параметров и статусов.',
        'Просмотр деталей и редактирование.',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
    <Paragraph>
      <Text strong>Видео 2:</Text> Создание рассылки.
    </Paragraph>
    <List
      size="small"
      dataSource={[
        'Переход в раздел “Клиенты”.',
        'Отправка сообщения всей базе.',
        'Поиск, сегментация и фильтры.',
        'Создание рассылки через кнопку “Действия”.',
        'Настройка параметров (текст, переменные, медиафайлы, теги, периодичность и т.д.).',
        'Просмотр информации в разделе “Рассылки”.',
      ]}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    /> */}
  </Typography>
);
